import { ApiUtility } from "../../Utilities/ApiUtility.axios";
class CurrencyServices {
  route = `V1/API/Billing/Acc_Currency`;

  getCurrencyList = (
    companyId: string | undefined,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    search?: string,
    searchColumnCount?: number,
    requestModel?: any
  ) =>
    ApiUtility.get(`${this.route}/${companyId}`, {
      start,
      length,
      sortCol,
      sortDir,
      search,
      searchColumnCount,
      requestModel,
    });

  postCurrency = (param: any, clientId?: string, id?: number) =>
    ApiUtility.post(
      `${this.route}/${id ? clientId + "/" + id : clientId + ""}`,
      param
    );

  getCurrency = (clientId?: string, id?: number) =>
    ApiUtility.get(`${this.route}/${clientId}`, id);

  deleteCurrency = (clientId: string | undefined, unitId: any) =>
    ApiUtility.delete(`${this.route}/${clientId}/${unitId}`);
}

export default new CurrencyServices();
